// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Step } from '@med/app/home/demo/guided-tour/models/step';
import { Store } from '@ngrx/store';
import { stepUpdated } from '@med/app/home/demo/guided-tour/store/guided-tour.actions';
import { Subject } from 'rxjs';

@Injectable()
export class GuidedTourService {

  private exitDemoClicks$ = new Subject<void>();
  readonly exitDemoClicked$ = this.exitDemoClicks$.asObservable();
  private nextClicks$ = new Subject<void>();
  readonly nextClicked$ = this.nextClicks$.asObservable();
  private portalClicks$ = new Subject<void>();
  readonly portalClicked$ = this.portalClicks$.asObservable();

  constructor(
    private store: Store,
  ) {
  }

  emitExitDemoClick(): void {
    this.exitDemoClicks$.next();
  }

  emitNextStepClick(): void {
    this.nextClicks$.next();
  }

  emitPortalClick(): void {
    this.portalClicks$.next();
  }

  show(step: Step): void {
    this.store.dispatch(stepUpdated({step}));
  }
}
